import * as React from "react";
const SvgFiRrSquareS = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-s_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM8 8.622a1.63 1.63 0 0 0 1.179 1.561l6.186 1.704A3.644 3.644 0 0 1 18 15.374 3.63 3.63 0 0 1 14.374 19H9.588a3.615 3.615 0 0 1-3.574-3.014 1 1 0 1 1 1.972-.336A1.62 1.62 0 0 0 9.589 17h4.786c.896 0 1.626-.729 1.626-1.626 0-.721-.484-1.363-1.176-1.562l-6.183-1.703a3.64 3.64 0 0 1-2.641-3.486 3.626 3.626 0 0 1 3.622-3.622h4.79a3.615 3.615 0 0 1 3.574 3.014 1 1 0 0 1-1.972.336 1.62 1.62 0 0 0-1.603-1.35h-4.79C8.727 7.001 8 7.729 8 8.623z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-s_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareS;
